import {env} from "../../../res/config/env";
import {lazy, Suspense} from "react";

const BrandYules = lazy(() => import("../yules/BrandYules.js"));
const BrandDebriar = lazy(() => import('../debriar/BrandDebriar.js'));
const BrandSuthbros = lazy(() => import('../suthbros/BrandSuthbros.js'));

const BrandSwitcher = ({ children }) => {

    if(env.WEBSITE_NAME === "Debriar") {
        return (
            <Suspense>
                <BrandDebriar>{children}</BrandDebriar>
            </Suspense>
        )
    } else if(env.WEBSITE_NAME === "Yules") {
        return (
            <Suspense>
                <BrandYules>{children}</BrandYules>
            </Suspense>
        )
    }  else {
        return (
            <Suspense>
                <BrandSuthbros>{children}</BrandSuthbros>
            </Suspense>
        )
    }


}

export default BrandSwitcher;
